document.addEventListener('DOMContentLoaded', function () {
  var bookingUrl = 'https://calendly.com/aina_hussain/free-introductory-call';
  var root = document.querySelector('.kaloneu-editorial-home, .kaloneu-home-refresh, [data-kaloneu-home]') || document;
  var links = root.querySelectorAll('a');
  links.forEach(function (link) {
    var text = (link.textContent || '').trim().toLowerCase();
    if (text.indexOf('book a consultation') !== -1 || text.indexOf('book a free introductory call') !== -1 || text.indexOf('start your health journey') !== -1) {
      link.href = bookingUrl;
      link.textContent = 'Book a Free Introductory Call';
      link.target = '_blank';
      link.rel = 'noopener';
    }
  });
});